<template>
<div>
  <div class="search-container">
   <searchbar :value="query.search" @search="search" :model="model"></searchbar>
  </div>
  <general-listing
    @sorting="sorting"
    @itemDelete="itemDelete"
    :loading="loading"
    :data="items"
    :structure="collectionData"
    :params="{ global_sorting: true, sort_by: this.query.sort_by, sort_order: this.query.sort_order}"
    model="user"
    :has_searched="has_searched"
  />
  <pagination
    @goToPage="goToPage"
    :page="page"
    :total-pages="total_pages"
  />
  <user-invite/>
  <user-invite-xls/>
</div>
</template>
<script>
import Api from '@/api/User'
import Ui from '@/classes/Ui'
import { EventBus } from '@/EventBus.js';
import {collectionMixin} from '@/components/mixins/Collection'
import UserInvite from '@/components/pages/users/UserInvite'
import UserInviteXls from '@/components/pages/users/UserXlsInvite'
import UserRoleSelect from '@/components/helpers/Specific/UserRoleSelect'
import Searchbar from '@/components/layouts/partials/Searchbar.vue'
import GeneralListing from '@/components/helpers/Specific/GeneralListing'

let structure = [
  { name: 'id', credentials: "is_root"},
  { name: 'firstname', sortable: true },
  { name: 'lastname', sortable: true },
  { name: 'email', type: 'valid_email', sortable: true },
  { name: 'role', credentials: 'admin'},
  { name: 'created_at', type: 'date' },
  { name: 'status', type: 'status'},
  { name: 'organization.name', sortable: true, credentials: 'root', alias: 'organization_name'},
  { name: 'action', type: 'crud_action_folded', exclude: ['show', 'duplicate'] }
]

let default_sort_by = "id"
let default_sort_order = "DESC"
let default_filters = {}

export default {
  mixins: [collectionMixin],
  components: {
    UserInvite,
    UserInviteXls,
    UserRoleSelect,
    Searchbar,
    GeneralListing
  },
  data(){
    return {
      model: "users",
      api: new Api(),
      collectionData: structure,
      title: "ui.pages.users",
      loading: false,
      query: { },
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_USERS',
        routerName: 'users',
        emptyState: 'users',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    }
  },
  mounted(){
    if (this.page != Ui.getCurrentPageUsers()) {
      this.goToPage(Ui.getCurrentPageUsers())
    }
    Ui.setSecondaryHeaderTabs({})
    Ui.setHeaderButtons([
      { name: "users_xls", action: "users.invite_xls", classes: "btn-tertiary", icon: "" },
      { name: "users", action: "users.invite", classes: "btn-primary", icon: "" }
    ])
    // reload when a user is invited
    EventBus.$on('action', (payload)=>{
      if(payload == 'user_invited'){
        this.retrieve()
      }
    })
  },
  created(){
    //  In case we generate a query, we create it before to be able to retrieve it in collection and display the specific list.
    this.initQuery()
  },
  methods: {
    emailError() {
      if (!this.has_valid_email) {
        document.getElementsByClassName("user-email").className += "warning-email";
      }
    }
  }
}
</script>
<style lang="scss">
.collection.user{
  .table{
    table-layout: auto;
  }
  .user-email{
    white-space: nowrap;
    color: black;
  }
  .user-action{
    width: 10px;
  }
  .value-valid-email{
    &.is-not-valid{
      color: red;
    }
  }
}
.search-container{
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  justify-content: space-between;
  .searchbar{
    margin-bottom: 1em;
    width: 100%;
  }
  .filter-trigger{
    user-select: none;
    cursor: pointer;
  }
  .icon-sliders {
    color: $onyx-light;
  }
}
</style>



// WEBPACK FOOTER //
// Users.vue?2eaba47b